import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useCollection, resolveAssetUrl, resolveCmsList } from "../../public-cms/hooks";

function TestimonialOne({ data = {} }) {
  const cms = useCollection("/public/reviews", { featured: "true" });
  const { loading, items: reviews } = resolveCmsList(cms);
  const testimonials = reviews.map((r) => ({
    name: r.reviewerName,
    designation: r.reviewerCountry || "Traveller",
    image: resolveAssetUrl(r.reviewerPhoto) || "/assets/img/testimonial/testi_1_1.jpg",
    text: r.reviewText,
    rating: r.rating || 5,
  }));
  if (loading || testimonials.length === 0) return null;

  const useCarousel = testimonials.length > 3;

  return (
    <section className="di-testimonials space" id="testi-sec">
      <div className="container">
        <div className="title-area text-center mb-40">
          <span className="sub-title di-section-script">{data.subTitle || "Testimonials"}</span>
          <h2 className="sec-title">{data.title || "What Clients Say About Us"}</h2>
        </div>

        {useCarousel ? (
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
            className="di-testimonials__slider"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={`${item.name}-${index}`}>
                <TestimonialTile item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="di-testimonials__grid">
            {testimonials.map((item, index) => (
              <TestimonialTile key={`${item.name}-${index}`} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

function TestimonialTile({ item }) {
  const stars = Math.min(5, Math.max(1, Number(item.rating) || 5));
  return (
    <article className="di-testimonial-card">
      <div className="di-testimonial-card__quote" aria-hidden="true">
        <i className="fa-solid fa-quote-left" />
      </div>
      <p className="di-testimonial-card__text">{item.text}</p>
      <div className="di-testimonial-card__stars">
        {[...Array(stars)].map((_, i) => (
          <i key={i} className="fa-solid fa-star" />
        ))}
      </div>
      <div className="di-testimonial-card__profile">
        <img src={item.image} alt={`${item.name} — traveller`} width="52" height="52" loading="lazy" decoding="async" />
        <div>
          <h3 className="di-testimonial-card__name">{item.name}</h3>
          <span className="di-testimonial-card__role">{item.designation}</span>
        </div>
      </div>
    </article>
  );
}

export default TestimonialOne;
